import Grid from '@mui/material/Grid'
import {QUESTION_TYPE} from '../../../../utils/constants'
import {Emoji} from 'emoji-picker-react'
import {Config} from '../../../../utils/Config'

import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Stack,
} from '@mui/material'
import StyledTableRow from '../../../../components/common/StyledComponents/StyledTableRow'
import HeaderTableCell from '../../../../components/common/StyledComponents/HeaderTableCell'
import QuestionCategoryBadge from '../../../../components/screens/surveyForms/questions/QuestionCategoryBadge'

export default function SingleQuestion({audience, question, qNo}) {
  const questionCategoryName =
    question?.categoryName || question?.CategoryName || question?.categoryname

  const renderQuestionType = () => (
    <h3 style={{margin: 0}}>
      <b>Question Type: </b>
      {question.questionType === QUESTION_TYPE.NUMBER_SLIDER
        ? 'Number Slider'
        : question.questionType === QUESTION_TYPE.PERCENTAGE
          ? 'Percentage'
          : question.questionType === QUESTION_TYPE.LIKERT
            ? 'Likert Scale'
            : question.questionType === QUESTION_TYPE.COMMENTS
              ? 'Comments'
              : question.questionType === QUESTION_TYPE.MULTIPLE_CHOICE
                ? 'Multiple Choice'
                : question.questionType === QUESTION_TYPE.MULTIPLE_SELECT
                  ? 'Multiple Select'
                  : question.questionType === QUESTION_TYPE.YES_NO
                    ? 'Yes/No'
                    : question.questionType === QUESTION_TYPE.YES_NO_MAYBE
                      ? 'Yes/No/Maybe'
                      : 'Other'}
    </h3>
  )
  const renderText = () => (
    <h3>
      <b>Question {qNo}: </b>
      {renderAudienceText(question)}
    </h3>
  )
  const renderAudienceText = text =>
    audience === 1
      ? text?.staffText
      : audience === 2
        ? text?.parentText
        : text?.pupilText

  const showLabel = option => {
    if (question.isImageOption) {
      if (audience === 1 && option.showStaffImageLabel) {
        return true
      }
      if (audience === 2 && option.showParentImageLabel) {
        return true
      }
      if (audience === 4 && option.showPupilImageLabel) {
        return true
      }
    }
    if (question.isEmojiOption) {
      if (audience === 1 && option.showStaffEmojiLabel) {
        return true
      }
      if (audience === 2 && option.showParentEmojiLabel) {
        return true
      }
      if (audience === 4 && option.showPupilEmojiLabel) {
        return true
      }
    }
    return false
  }

  const renderFollowupQuestions = () => (
    <div>
      {question.followupQuestions.map((followup, index) => (
        <Stack direction={'column'} spacing={1}>
          <Stack direction={'row'} alignItems={'center'} columnGap={1}>
            <strong>Follow-up Question:</strong>
            {audience === 1
              ? followup.staffFollowupText
              : audience === 2
                ? followup.parentFollowupText
                : followup.pupilFollowupText}
          </Stack>
          {question.questionType === QUESTION_TYPE.NUMBER_SLIDER ||
          question.questionType === QUESTION_TYPE.PERCENTAGE ? (
            followup.followupValue
          ) : (
            <Stack direction={'row'} alignItems={'center'} columnGap={1}>
              <strong>Condition:</strong>
              {renderAudienceText(
                question.multiOptionResponseAttributes.find(
                  x => x.value === followup.followupValue
                )
              )}
            </Stack>
          )}
        </Stack>
      ))}
    </div>
  )

  const renderOptions = () => {
    if (
      question.questionType === QUESTION_TYPE.COMMENTS ||
      question.questionType === QUESTION_TYPE.NUMBER_SLIDER ||
      question.questionType === QUESTION_TYPE.PERCENTAGE
    ) {
      return ''
    }
    return (
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <HeaderTableCell>Answer Options</HeaderTableCell>
              <HeaderTableCell>Num Score</HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {question.multiOptionResponseAttributes
              .sort((a, b) => a.order - b.order)
              .map((option, index) => (
                <StyledTableRow key={index}>
                  <TableCell>
                    {question.isTextOption && renderAudienceText(option)}
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      columnGap={1}
                    >
                      {question.isEmojiOption && (
                        <Emoji unified={option.pupilEmoji} />
                      )}
                      {question.isImageOption && (
                        <img
                          style={{width: '50px', height: '50px'}}
                          src={`${Config.BASE_URL}/Artifact/download?fileName=${option.pupilImage}`}
                          alt="Option"
                        />
                      )}{' '}
                      {showLabel(option) && renderAudienceText(option)}
                    </Stack>
                  </TableCell>
                  <TableCell>{option.numValue}</TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  const renderSettings = () => (
    <div>
      {question.questionType === QUESTION_TYPE.MULTIPLE_SELECT &&
      question.questionSettings ? (
        <Stack direction={'row'} alignItems={'center'} columnGap={1}>
          <strong>Participant can select:</strong>
          {question.questionSettings.multiSelectOperator === 1
            ? 'Exactly '
            : question.questionSettings.multiSelectOperator === 2
              ? 'atleast '
              : question.questionSettings.multiSelectOperator === 3
                ? 'at most '
                : ''}
          {question.questionSettings.multiSelectValue}
        </Stack>
      ) : (
        ''
      )}
    </div>
  )

  return (
    <div className="view-all-questions">
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Stack direction={'column'} spacing={1.5}>
            <QuestionCategoryBadge categoryName={questionCategoryName} />
            <div>{renderText()}</div>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <div>{renderQuestionType()}</div>
              <div>{renderSettings()}</div>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {renderOptions()}
        </Grid>
        <Grid item xs={12}>
          {renderFollowupQuestions()}
        </Grid>
      </Grid>
    </div>
  )
}
